<template>
  <div id="assign-member-redesign">
    <overlay-loading-progress
      :LoadingFlag="OverlayLoadingFlag"
    ></overlay-loading-progress>
    <!-- Document Upload Dialog -->
    <v-dialog v-model="memberDocumentPrompt" persistent max-width="70%">
      <add-lom-document
        pageTitle="Upload Directory Information"
        pageDescription="Upload Directory Information"
        :recordData="SelectedMember"
        :addRecordPrompt="memberDocumentPrompt"
        @hideAddRecordPrompt="hideMemberDocumentPrompt($event)"
        v-if="memberDocumentPrompt"
        :UserInterface="2"
      ></add-lom-document>
    </v-dialog>
    <!-- Main Card -->
    <v-card class="assignment-card elevation-8 rounded-xl overflow-hidden">
      <!-- Premium Header -->
      <div class="premium-header">
        <div class="header-background"></div>
        <div class="header-content">
          <div class="header-title-section">
            <div class="title-icon-wrapper">
              <v-icon color="white" size="36">mdi-account-check</v-icon>
            </div>
            <div class="title-text-section">
              <h1 class="header-title">Assign Member</h1>
            </div>
          </div>
          <v-btn icon dark @click="closePrompt" class="close-btn">
            <v-icon size="24">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <!-- Scrollable Content -->
      <v-sheet
        id="assign-content"
        class="overflow-y-auto content-area"
        max-height="700"
      >
        <v-container class="content-container">
          <v-form ref="form1" v-model="valid1" lazy-validation>
            <!-- Step 1: Search Section -->
            <v-card class="search-card rounded-xl elevation-2 step-card">
              <v-card-text class="pa-6">
                <!-- Step indicator -->
                <div class="step-indicator">
                  <div class="step-number">1</div>
                  <div class="step-text">
                    <div class="step-title">Search Member</div>
                    <div class="step-desc">
                      Enter designation and membership ID
                    </div>
                  </div>
                </div>

                <v-divider class="my-4"></v-divider>

                <v-row dense>
                  <!-- Designation Dropdown -->
                  <v-col cols="12" sm="6">
                    <div class="input-label">
                      <span class="required-mark">*</span>
                      Designation
                    </div>
                    <v-autocomplete
                      v-model="DesignationId"
                      :items="DesignationIdOptions"
                      :loading="DesignationIdOptionsLoading"
                      :rules="DesignationIdRules"
                      outlined
                      dense
                      clearable
                      hide-details="auto"
                      placeholder="Select designation"
                      prepend-inner-icon="mdi-shield-account"
                      class="modern-input"
                      :reduce="(option) => option.value"
                    ></v-autocomplete>
                  </v-col>

                  <!-- Membership ID Text Box -->
                  <v-col cols="12" sm="6">
                    <div class="input-label">
                      <span class="required-mark">*</span>
                      Membership ID
                    </div>
                    <v-text-field
                      v-model="MembershipId"
                      outlined
                      dense
                      placeholder="e.g., 1132220"
                      prepend-inner-icon="mdi-card-account-details"
                      class="modern-input"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- Search Button -->
                <v-row class="mt-4">
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="searchMember"
                    color="primary"
                    :loading="LoadingFlag"
                    :disabled="!MembershipId || !DesignationId"
                    class="search-btn px-8"
                    large
                  >
                    <v-icon left>mdi-magnify</v-icon>
                    Search Member
                  </v-btn>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Loading State -->
            <div v-if="LoadingFlag" class="loading-container">
              <v-progress-circular
                indeterminate
                color="primary"
                size="60"
              ></v-progress-circular>
              <p class="loading-text">Searching for member...</p>
            </div>

            <!-- Portal Details and Aadhaar Details - Two Column Layout -->
            <v-expand-transition>
              <v-row
                v-if="
                  MemberFlag && SelectedMember.MembershipId && SelectedMember
                "
                class="mt-2"
              >
                <!-- Portal Details Card -->
                <v-col cols="12" md="6">
                  <v-card
                    class="portal-details-card rounded-lg elevation-2 h-100"
                  >
                    <!-- Header -->
                    <div class="portal-header">
                      <v-icon color="white" left
                        >mdi-information-outline</v-icon
                      >
                      <span>Portal Details</span>
                    </div>

                    <v-card-text class="pa-6">
                      <div class="portal-details-grid">
                        <!-- Row 1 -->
                        <div class="detail-item">
                          <div class="detail-label">Active Status</div>
                          <div class="detail-value status-approved">
                            <v-icon x-small left>mdi-check-circle</v-icon>
                            Approved
                          </div>
                        </div>

                        <div class="detail-item">
                          <div class="detail-label">Zone</div>
                          <div class="detail-value">
                            {{ SelectedMember.ZoneName || "N/A" }}
                          </div>
                        </div>

                        <div class="detail-item">
                          <div class="detail-label">Email</div>
                          <div class="detail-value">
                            {{ SelectedMember.EmailId || "N/A" }}
                          </div>
                        </div>

                        <!-- Row 2 -->
                        <div class="detail-item">
                          <div class="detail-label">Local Organization</div>
                          <div class="detail-value">
                            {{ SelectedMember.LomName || "N/A" }}
                          </div>
                        </div>

                        <div class="detail-item">
                          <div class="detail-label">Designation</div>
                          <div class="detail-value">
                            {{ SelectedMember.Designation || "N/A" }}
                          </div>
                        </div>

                        <div class="detail-item">
                          <div class="detail-label">Date of Birth</div>
                          <div class="detail-value">
                            {{ SelectedMember.MemberDOB || "N/A" }}
                          </div>
                        </div>

                        <!-- Row 3 -->
                        <div class="detail-item">
                          <div class="detail-label">Contact</div>
                          <div class="detail-value">
                            {{ SelectedMember.MobileNo || "N/A" }}
                          </div>
                        </div>

                        <div class="detail-item">
                          <div class="detail-label">Profile Update</div>
                          <div
                            class="detail-value"
                            :class="
                              SelectedMember.ProfileUpdated
                                ? 'status-updated'
                                : 'status-not-updated'
                            "
                          >
                            <v-icon x-small left>{{
                              SelectedMember.ProfileUpdated
                                ? "mdi-check-circle"
                                : "mdi-clock"
                            }}</v-icon>
                            {{
                              SelectedMember.ProfileUpdatedTxt || "Not Updated"
                            }}
                          </div>
                        </div>

                        <div class="detail-item">
                          <div class="detail-label">Aadhaar Verification</div>
                          <div
                            class="detail-value"
                            :class="
                              SelectedMember.AadhaarVerifiedFlag
                                ? 'status-verified'
                                : 'status-not-verified'
                            "
                          >
                            <v-icon x-small left>{{
                              SelectedMember.AadhaarVerifiedFlag
                                ? "mdi-check-circle"
                                : "mdi-alert-circle"
                            }}</v-icon>
                            {{
                              SelectedMember.AadhaarVerifiedTxt ||
                              "Not Verified"
                            }}
                          </div>
                        </div>

                        <!-- Missing Steps -->
                        <div
                          v-if="
                            SelectedMember.MissingSteps &&
                            SelectedMember.MissingSteps.length > 0
                          "
                          class="detail-item"
                        >
                          <div class="detail-label">Missing Steps</div>
                          <div class="detail-value status-warning">
                            <v-icon x-small left>mdi-alert-outline</v-icon>
                            <span
                              >{{ SelectedMember.MissingSteps }} Pending</span
                            >
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>

                <!-- Aadhaar Details Card -->
                <v-col cols="12" md="6">
                  <v-card
                    class="aadhaar-details-card rounded-lg elevation-2 h-100"
                  >
                    <!-- Header -->
                    <div
                      v-if="SelectedMember.AadhaarVerifiedFlag"
                      class="aadhaar-header verified"
                    >
                      <v-icon color="white" left>mdi-shield-check</v-icon>
                      <span>Verified Aadhaar Details</span>
                    </div>
                    <div v-else class="aadhaar-header not-verified">
                      <v-icon color="white" left>mdi-shield-alert</v-icon>
                      <span>Verified Aadhaar Details</span>
                    </div>

                    <v-card-text class="pa-6">
                      <div
                        v-if="!SelectedMember.AadhaarVerifiedFlag"
                        class="aadhaar-empty-state"
                      >
                        <v-icon size="48" color="#e11d48" class="mb-4"
                          >mdi-alert-circle</v-icon
                        >
                        <p class="empty-title">Aadhaar details not found</p>
                        <p class="empty-subtitle">
                          No Aadhaar record is available for this member. Please
                          request Aadhaar verification or upload Aadhaar
                          document.
                        </p>
                      </div>

                      <div v-else>
                        <!-- Aadhaar Name -->
                        <div class="detail-row">
                          <div class="detail-label">Full Name</div>
                          <div class="detail-value">
                            {{ SelectedMember.AadhaarName || "N/A" }}
                          </div>
                        </div>

                        <!-- Aadhaar DOB -->
                        <div class="detail-row">
                          <div class="detail-label">Date of Birth</div>
                          <div class="detail-value">
                            {{ SelectedMember.AadhaarDob || "N/A" }}
                          </div>
                        </div>

                        <!-- Aadhaar Gender -->
                        <div class="detail-row">
                          <div class="detail-label">Gender</div>
                          <div class="detail-value">
                            {{ SelectedMember.AadhaarGender || "N/A" }}
                          </div>
                        </div>

                        <!-- Aadhaar Number -->
                        <div class="detail-row">
                          <div class="detail-label">Aadhaar Number</div>
                          <div class="detail-value font-monospace">
                            {{
                              SelectedMember.AadhaarNumber || "XXXX XXXX XXXX"
                            }}
                          </div>
                        </div>

                        <!-- Aadhaar Address -->
                        <div class="detail-row">
                          <div class="detail-label">Registered Address</div>
                          <div class="detail-value address-text">
                            {{ SelectedMember.AadhaarAddress || "N/A" }}
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>

                <!-- Age Proof Document Card -->
                <v-col cols="12" md="6">
                  <v-card class="age-proof-card rounded-lg elevation-2 h-100">
                    <!-- Header -->
                    <div class="age-proof-header">
                      <v-icon color="white" left>mdi-file-image</v-icon>
                      <span>Age Proof Document</span>
                    </div>

                    <v-card-text class="pa-6">
                      <div
                        v-if="!SelectedMember.PhotoUrl"
                        class="document-empty-state"
                      >
                        <v-icon size="48" color="#9ca3af" class="mb-4"
                          >mdi-image-off</v-icon
                        >
                        <p class="empty-title">No document available</p>
                        <p class="empty-subtitle">
                          Age proof document image is not uploaded for this
                          member.
                        </p>
                      </div>

                      <div v-else class="document-image-container">
                        <viewer rebuild :images="[SelectedMember.PhotoUrl]">
                          <div class="document-image-wrapper">
                            <img
                              :src="SelectedMember.PhotoUrl"
                              alt="Age Proof Document"
                              class="document-image"
                            />
                          </div>
                        </viewer>
                        <div class="document-info">
                          <div class="info-item">
                            <span class="info-label">Document Type</span>
                            <span class="info-value">Age Proof</span>
                          </div>
                          <div class="info-item">
                            <span class="info-label">Member</span>
                            <span class="info-value">{{
                              SelectedMember.MemberName || "N/A"
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-expand-transition>

            <br />
            <!-- Step 2: Member Details -->
            <v-expand-transition>
              <v-card
                v-if="MemberFlag"
                class="info-card rounded-xl elevation-2 step-card"
              >
                <v-card-text class="pa-6">
                  <div class="step-indicator">
                    <div class="step-number success">2</div>
                    <div class="step-text">
                      <div class="step-title">Member Information</div>
                      <div class="step-desc">Verified member details</div>
                    </div>
                  </div>

                  <v-divider class="my-4"></v-divider>

                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <div class="info-field">
                        <div class="info-label">Full Name</div>
                        <div class="info-value font-weight-bold">
                          {{ SelectedMember.MemberName || "N/A" }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="info-field">
                        <div class="info-label">Membership ID</div>
                        <div class="info-value font-weight-bold">
                          {{ SelectedMember.MembershipId || "N/A" }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="info-field">
                        <div class="info-label">Zone</div>
                        <div class="info-value">
                          {{ SelectedMember.ZoneName || "N/A" }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="info-field">
                        <div class="info-label">Local Organization</div>
                        <div class="info-value">
                          {{ SelectedMember.LomName || "N/A" }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="info-field">
                        <div class="info-label">Email Address</div>
                        <div class="info-value">
                          {{ SelectedMember.EmailId || "N/A" }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="info-field">
                        <div class="info-label">Mobile Number</div>
                        <div class="info-value">
                          {{ SelectedMember.MobileNo || "N/A" }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expand-transition>

            <!-- Step 3: Document Upload -->
            <v-expand-transition>
              <v-card
                v-if="MemberFlag"
                class="document-card rounded-xl elevation-2 step-card"
              >
                <v-card-text class="pa-6">
                  <div class="step-indicator">
                    <div class="step-number warning">3</div>
                    <div class="step-text">
                      <div class="step-title">Document Upload</div>
                      <div class="step-desc">
                        Directory information documents
                      </div>
                    </div>
                  </div>

                  <v-divider class="my-4"></v-divider>

                  <v-row dense>
                    <v-col cols="12" sm="6">
                      <div
                        v-if="SelectedMember.LomDocumentPathArray && SelectedMember.LomDocumentPathArray.length > 0"
                        class="document-links"
                      >
                        <v-list dense class="pa-0 document-list">
                          <v-list-item
                            v-for="(
                              row, index
                            ) in SelectedMember.LomDocumentPathArray"
                            :key="index"
                            class="document-list-item"
                          >
                            <v-list-item-icon class="mr-2">
                              <v-icon color="primary">mdi-file-pdf-box</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="document-link">
                                <a
                                  :href="row"
                                  target="_blank"
                                  class="text-decoration-none"
                                >
                                  Directory Information Document {{ index + 1 }}
                                </a>
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-btn
                                icon
                                small
                                color="primary"
                                :href="row"
                                target="_blank"
                              >
                                <v-icon small>mdi-download</v-icon>
                              </v-btn>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </div>
                      <div
                        v-else
                        class="document-upload-prompt d-flex align-center"
                      >
                        <v-chip color="#f4b400" label dark class="mr-3">
                          <v-icon left small>mdi-alert-circle</v-icon>
                          Pending
                        </v-chip>
                      </div>
                      <br />
                      <v-btn
                        @click="memberDocumentPrompt = true"
                        color="warning"
                        outlined
                        block
                        class="upload-btn py-4"
                      >
                        <v-icon left>mdi-cloud-upload</v-icon>
                        Upload Directory Document
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-expand-transition>

            <!-- Step 4: Reason -->
            <v-expand-transition>
              <v-card
                v-if="MemberFlag"
                class="reason-card rounded-xl elevation-2 step-card"
              >
                <v-card-text class="pa-6">
                  <div class="step-indicator">
                    <div class="step-number danger">4</div>
                    <div class="step-text">
                      <div class="step-title">Assignment Reason</div>
                      <div class="step-desc">
                        Provide reason for this assignment (mandatory)
                      </div>
                    </div>
                  </div>

                  <v-divider class="my-4"></v-divider>

                  <div class="input-label">
                    <span class="required-mark">*</span>
                    Reason for Assignment
                  </div>
                  <v-textarea
                    v-model="Reason"
                    :rules="ReasonRules"
                    placeholder="Please provide detailed reason..."
                    outlined
                    dense
                    rows="5"
                    counter="500"
                    maxlength="500"
                    class="modern-input"
                    prepend-icon="mdi-comment-text"
                  ></v-textarea>
                </v-card-text>
              </v-card>
            </v-expand-transition>
          </v-form>
        </v-container>
      </v-sheet>

      <!-- Footer Actions -->
      <v-divider></v-divider>
      <v-card-actions class="footer-actions">
        <v-spacer></v-spacer>
        <v-btn @click="closePrompt" outlined color="grey" class="action-btn">
          <v-icon left>mdi-close</v-icon>
          Cancel
        </v-btn>
        <v-btn
          @click="confirmAlert(3)"
          :disabled="!valid1 || !MemberFlag"
          :loading="SubmitFlag"
          outlined
          color="error"
          class="action-btn"
        >
          <v-icon left>mdi-close-circle</v-icon>
          Keep Pending
        </v-btn>
        <v-btn
          @click="confirmAlert(1)"
          :disabled="!valid1 || !MemberFlag"
          :loading="SubmitFlag"
          color="success"
          class="action-btn white--text"
        >
          <v-icon left>mdi-check-circle</v-icon>
          Approve
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import UploadSelectedMemberDocument from "@/view/pages/members/UploadSelectedMemberDocument.vue";
import UploadSelectedMemberPhoto from "@/view/pages/members/UploadSelectedMemberPhoto.vue";
import Swal from "sweetalert2";
import AddLomDocument from "@/view/pages/erp/reports/AddLomDocument.vue";
import { CircleStencil, Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  mixins: [common],
  components: {
    UploadSelectedMemberDocument,
    UploadSelectedMemberPhoto,
    AddLomDocument,
    Cropper,
    CircleStencil,
  },
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageDescription: {
      type: String,
    },
    PageTitle: {
      type: String,
    },
  },
  data() {
    return {
      valid1: true,
      showAadhaarDetails: true,

      menu1: false,
      SelectedMember: {},

      memberDocumentPrompt: false,
      memberPhotoPrompt: false,

      search: "",
      selected: [],
      tableSelectFlag1: false,
      SubmitFlag: false,
      ResultFlag: false,

      rows: [],
      tableColumns1: [],
      records: [],

      alert: {},

      ProgessStart: 0,
      uploadPercentage: 0,

      SuccessMessageTxtFlag: 0,
      SuccessMessageTxt: "",

      ErrorMessageTxtFlag: 0,
      ErrorMessageTxt: "",

      ResultFlag: false,
      LoadingFlag: false,
      StartupLoadingFlag: false,

      AllMembers: [],

      LomCode: "",
      CurrentYearId: "",

      YearCodeRules: [(v) => !!v || "Year is required"],
      YearCode: "",
      YearCodeOptions: [],
      YearCodeOptionsLoading: false,

      TeamCodeRules: [(v) => !!v || "Team is required"],
      TeamCode: "",
      TeamCodeOptions: [],
      TeamCodeOptionsLoading: false,

      ZoneCodeRules: [],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      LomCodeRules: [],
      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      MembershipId: "",
      MemberFlag: false,
      OverlayLoadingFlag: false,

      MemberIdRules: [(v) => !!v || "Member is required"],
      MemberId: "",
      MemberIdOptions: [],
      MemberIdOptionsLoading: false,

      DesignationIdRules: [(v) => !!v || "Designation is required"],
      DesignationId: "",
      DesignationIdOptions: [],
      DesignationIdOptionsLoading: false,

      MemberNameRules: [(v) => !!v || "Member Name is required"],
      MemberName: "",

      EmailIdRules: [],
      EmailId: "",

      MobileNoRules: [],
      MobileNo: "",

      Address: "",

      CityNameRules: [],
      CityName: "",

      uploadedImages: [],

      FacebookRules: [],
      Facebook: "",

      TwitterRules: [],
      Twitter: "",

      InstagramRules: [],
      Instagram: "",

      MemberTypeId: "",

      ReasonRules: [(v) => !!v || "Reason is required"],
      Reason: "",

      PageInfo: {},
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",

      uploads: {},
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = NextJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;

        this.pageData();
      }
    },
    dialog(val) {
      val || this.close();
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      this.LoadingFlag = false;
      this.ZoneCodeOptionsLoading = false;
    },
    ZoneCode: function () {
      console.log("watch ZoneCode");
      // this.getRegionCodeOptions();
      this.LomCode = "";
      this.getLomCodeOptions();
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions");
      this.LoadingFlag = false;
      this.LomCodeOptionsLoading = false;
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    rows: function () {
      console.log("watch rows");
      var n1 = this.rows.length;
      var flag = n1 == 0 ? 0 : 1;
      console.log("n1=" + n1 + ", flag=" + flag);
      this.records = this.rows[0];
    },
    YearCodeOptions: function () {
      this.YearCodeOptionsLoading = false;
    },
    TeamCodeOptions: function () {
      this.TeamCodeOptionsLoading = false;
    },
    MemberIdOptions: function () {
      this.MemberIdOptionsLoading = false;
    },
    DesignationIdOptions: function () {
      this.DesignationIdOptionsLoading = false;
    },
    DesignationId: function () {
      console.log("watch DesignationId");
      var DesignationId = this.DesignationId;
      if (DesignationId != "") {
        var MemberTypeId = "";
        switch (DesignationId) {
          case 14:
            // Junior Jaycee Wing
            MemberTypeId = 9;
            break;

          case 15:
            // Jayceert Wing
            MemberTypeId = 8;
            break;

          default:
            MemberTypeId = 1;
            break;
        }
        this.MemberTypeId = MemberTypeId;
        this.getMemberIdOptions();
      }
    },
    MembershipId: function () {
      console.log("watch MembershipId");
      this.SelectedMember = {};
      this.MemberFlag = false;
      this.Reason = "";
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    hideMemberDocumentPrompt(flag) {
      console.log("hideMemberDocumentPrompt called");
      console.log({ flag });
      this.memberDocumentPrompt = false;
      if (flag) {
        this.SelectedMember = {};
        this.MemberFlag = false;
      }
    },
    hideMemberPhotoPrompt(flag) {
      console.log("hideMemberPhotoPrompt called");
      console.log({ flag });
      this.memberPhotoPrompt = false;
      if (flag) {
        this.SelectedMember.photo_flag = true;
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "lgb_dis",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      this.getZoneCodeOptions();
    },
    pageData() {
      console.log("pageData called");
      this.getDesignationIdOptions();
    },
    validate() {
      console.log("validate called");
      this.$refs.form1.validate();
    },
    reset() {
      console.log("reset called");
      this.$refs.form1.reset();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideAssignMemberPrompt", this.ResultFlag);
    },
    resetMessageTxt() {
      console.log("resetMessageTxt called");
      this.ErrorMessageTxt = 0;
      this.ErrorMessageTxtFlag = "";
      this.SuccessMessageTxtFlag = 0;
      this.SuccessMessageTxt = "";
    },
    onFileSelected(event, k) {
      console.log("onFileSelected called");
      var n1 = this.uploadedImages.length;
      var file = event.target.files[0];
      console.log("k=" + k + ", event=" + JSON.stringify(file));
      this.uploadedImages[k] = file;
    },
    addNewRow(tableId) {
      console.log("addNewRow called");
      console.log("tableId=" + tableId);

      if (tableId == 2) {
        var n1 = this.AllMembers.length;
        console.log("n1=" + n1);
        // if (n1 < 30) {
        this.AllMembers.push({
          YearwiseOfficesHeldId: null,
          MemberId: 0,
          MemberName: "",
          DesignationId: 0,
          Designation: "",
        });
        // }
      }
    },
    deleteRow(tableId, index, tr) {
      console.log("deleteRow called");
      console.log(
        "tableId=" + tableId + ", index=" + index + ", tr=" + JSON.stringify(tr)
      );
      if (index > -1) {
        if (tableId == 2) {
          this.AllMembers.splice(index, 1);
        }
      }
    },
    getDesignationIdOptions() {
      console.log("getDesignationIdOptions called");
      this.DesignationIdOptionsLoading = true;
      var selectbox1_source = "DesignationId";
      var selectbox1_destination = "DesignationIdOptions";
      var selectbox1_url = "api/designation/options";
      var selectbox1_conditions_array = {
        UserInterface: 2,
        OrganizationTypeId: 3,
        ExceptDesignationId: [1, 5, 6, 7],
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getMemberIdOptions() {
      console.log("getMemberIdOptions called");
      this.MemberIdOptionsLoading = true;
      var selectbox1_source = "MemberId";
      var selectbox1_destination = "MemberIdOptions";
      var selectbox1_url = "api/members/options";
      var selectbox1_conditions_array = {
        UserInterface: 2,
        LomCode: this.LomCode,
        MemberType: this.MemberTypeId,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getMemberDetails() {
      console.log("getMemberDetails called");
      this.AllMembers = [];
      this.SelectedMember = {};
      this.MemberFlag = false;
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      var idx = this.MemberIdOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var member = this.MemberIdOptions[idx];
        console.log("member=" + JSON.stringify(member));
        var MembershipId = member.membership_id;
        MembershipId = MembershipId == (null || undefined) ? "" : MembershipId;
        console.log({ MembershipId });
        if (MembershipId != "") {
          this.MembershipId = MembershipId;
          this.searchForm();
        }
      }
    },
    searchForm() {
      console.log("searchForm is called");
      var MembershipId = this.MembershipId;
      console.log("MembershipId=" + MembershipId);
      this.SelectedMember = {};
      this.MemberFlag = false;
      if (MembershipId != "") {
        this.OverlayLoadingFlag = true;
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members/search";
        var upload = {
          UserInterface: 2,
          MembershipId: this.MembershipId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );
        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;
        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));
            // thisIns.pageLoadingOff()
            thisIns.OverlayLoadingFlag = false;
            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.SelectedMember = records;
              thisIns.MemberFlag = true;
              // thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.OverlayLoadingFlag = false;
          });
      } else {
        var message = "Membership Id is required";
        this.sweetAlert("error", message, false);
      }
    },
    confirmAlert(Status) {
      var validate1 = this.$refs.form1.validate();
      console.log({ validate1 });

      var status = Status;
      console.log({ status });
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "Please verify all information before saving.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          if (result.isConfirmed) {
            this.submitForm(status);
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        this.sweetAlert("error", "Kindly fill all required fields", false);
      }
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      var yearCode = 15;
      var areaCode = this.AreaCode;
      console.log("yearCode=" + yearCode + ", areaCode=" + areaCode);
      if (yearCode != "") {
        this.LoadingFlag = true;
        this.ZoneCodeOptionsLoading = true;
        var selectbox1_source = "ZoneCode";
        var selectbox1_destination = "ZoneCodeOptions";
        var selectbox1_url = "api/year-wise-lom/zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          YearCode: 15,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (yearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    searchMember() {
      console.log("searchMember called");
      var MembershipId = this.MembershipId;
      var DesignationId = this.DesignationId;

      if (!MembershipId || !DesignationId) {
        this.toast("error", "Please fill all required fields");
        return;
      }

      this.SelectedMember = {};
      this.MemberFlag = false;
      this.LoadingFlag = true;

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/nominate-member-subscription/info";

      var upload = {
        UserInterface: 2,
        Membership: MembershipId,
      };

      console.log("upload=" + JSON.stringify(upload));

      const thisIns = this;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));
          thisIns.LoadingFlag = false;

          var flag = response.data.flag;
          var output = response.data.output;
          var records = response.data.records;

          console.log("output=" + output + ", flag=" + flag);
          console.log({ records });

          if (flag == 1) {
            thisIns.SelectedMember = records;
            thisIns.MemberFlag = true;
            thisIns.toast("success", output);
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.LoadingFlag = false;
          thisIns.toast("error", "Error fetching member details");
        });
    },

    submitForm(status) {
      console.log("submitForm called");

      var result = this.$refs.form1.validate();
      var DesignationId = this.DesignationId;
      var MembershipId = this.MembershipId;
      var Reason = this.Reason;
      var Status = status;
      var CurrentYearId = this.CurrentYearId;

      console.log(
        "DesignationId=" +
          DesignationId +
          ", MembershipId=" +
          MembershipId +
          ", Reason=" +
          Reason +
          ", Status=" +
          Status
      );

      if (result && DesignationId && MembershipId && Reason && Status) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url =
          server_url + "api/year-wise-designation/assign-member-new";

        var upload = {
          UserInterface: 1,
          YearCode: CurrentYearId,
          MemberId: this.SelectedMember.MemberId,
          DesignationId: DesignationId,
          Reason: Reason,
          Status: Status,
        };

        console.log("upload=" + JSON.stringify(upload));

        this.SubmitFlag = true;
        const thisIns = this;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));
            thisIns.SubmitFlag = false;

            var flag = response.data.flag;
            var output = response.data.output;

            if (flag == 1) {
              thisIns.ResultFlag = true;
              thisIns.sweetAlert("success", output, true);
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
            thisIns.sweetAlert("error", "Error submitting form", false);
          });
      } else {
        this.sweetAlert("error", "Kindly fill all required fields", false);
      }
    },
  },
  beforeMount() {
    console.log("beforeMount called");
    this.refreshPageData();
  },
};
</script>

<style lang="scss">
// Color Palette
$primary-color: #2196f3;
$primary-dark: #1565c0;
$success-color: #10b981;
$warning-color: #f59e0b;
$danger-color: #ef4444;
$info-color: #3b82f6;
$light-bg: #f8fafc;
$border-color: #e2e8f0;
$text-primary: #1f2937;
$text-secondary: #6b7280;
$text-light: #9ca3af;

#assign-member-redesign {
  // Main card wrapper
  .assignment-card {
    border-radius: 16px !important;
    overflow: hidden;
    background: #ffffff !important;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08) !important;
  }

  // Premium Header with gradient background
  .premium-header {
    position: relative;
    background: linear-gradient(
      135deg,
      $primary-color 0%,
      $primary-dark 50%,
      #0d47a1 100%
    );
    color: white;
    padding: 0;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 400px;
      height: 400px;
      background: radial-gradient(
        circle,
        rgba(255, 255, 255, 0.15) 0%,
        transparent 70%
      );
      border-radius: 50%;
      pointer-events: none;
    }

    &::after {
      content: "";
      position: absolute;
      bottom: -50px;
      left: 0;
      right: 0;
      height: 100px;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.1) 0%,
        transparent 100%
      );
      pointer-events: none;
    }
  }

  .header-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(
        circle at 20% 50%,
        rgba(255, 255, 255, 0.15) 0%,
        transparent 50%
      ),
      radial-gradient(
        circle at 80% 80%,
        rgba(255, 255, 255, 0.1) 0%,
        transparent 50%
      );
    pointer-events: none;
  }

  .header-content {
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 28px;
    min-height: 100px;
  }

  .header-title-section {
    display: flex;
    align-items: center;
    gap: 18px;
    flex: 1;
    gap: 4px;
  }

  .header-title {
    color: #ffffff;
    font-weight: 700;
    font-size: 22px;
    margin: 0;
    letter-spacing: -0.3px;
  }

  .title-text-section {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .header-title {
      font-size: 32px;
      font-weight: 800;
      margin: 0;
      color: white;
      letter-spacing: -1px;
      text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }

    .header-subtitle {
      font-size: 14px;
      margin: 6px 0 0 0;
      color: rgba(255, 255, 255, 0.9);
      font-weight: 500;
      letter-spacing: 0.3px;
    }
  }

  .close-btn {
    width: 44px !important;
    height: 44px !important;
    background: rgba(255, 255, 255, 0.18) !important;
    border-radius: 10px !important;
    border: 1px solid rgba(255, 255, 255, 0.35) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &:hover {
      background: rgba(255, 255, 255, 0.28) !important;
      transform: rotate(90deg);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
    }

    &:active {
      background: rgba(255, 255, 255, 0.35) !important;
    }
  }

  // Content Area
  .content-area {
    background: $light-bg;
    flex: 1;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: #cbd5e1;
      border-radius: 4px;

      &:hover {
        background: #94a3b8;
      }
    }
  }

  .content-container {
    padding: 28px;
    max-width: 100%;
  }

  // Step Card Styles
  .step-card {
    border: none !important;
    border-radius: 12px !important;
    margin-bottom: 20px !important;
    background: white !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-left: 4px solid transparent;

    &:hover {
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1), 0 2px 6px rgba(0, 0, 0, 0.06) !important;
      transform: translateY(-2px);
    }
  }

  .search-card {
    background: linear-gradient(135deg, #ffffff 0%, #f8fbfe 100%) !important;
    border: 1px solid #e3f2fd !important;
    border-left-color: $primary-color !important;
  }

  .info-card {
    border-left-color: $info-color !important;
  }

  .portal-card {
    border-left-color: #06b6d4 !important;
  }

  .aadhaar-card {
    border-left-color: $success-color !important;
  }

  .document-card {
    border-left-color: $warning-color !important;
  }

  .reason-card {
    border-left-color: $danger-color !important;
  }

  // Step Indicator
  .step-indicator {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 4px;
  }

  .step-number {
    width: 44px;
    height: 44px;
    min-width: 44px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-size: 18px;
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
    color: $primary-color;
    box-shadow: 0 2px 8px rgba(33, 150, 243, 0.2);
    transition: all 0.3s ease;

    &.success {
      background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
      color: $success-color;
      box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
    }

    &.info {
      background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
      color: $info-color;
      box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
    }

    &.warning {
      background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
      color: $warning-color;
      box-shadow: 0 2px 8px rgba(245, 158, 11, 0.2);
    }

    &.danger {
      background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
      color: $danger-color;
      box-shadow: 0 2px 8px rgba(239, 68, 68, 0.2);
    }
  }

  .step-text {
    flex: 1;
  }

  .step-title {
    font-size: 16px;
    font-weight: 700;
    color: $text-primary;
    margin: 0;
    letter-spacing: -0.5px;
  }

  .step-desc {
    font-size: 13px;
    color: $text-secondary;
    margin: 4px 0 0 0;
    font-weight: 400;
  }

  // Input Labels
  .input-label {
    font-size: 13px;
    font-weight: 700;
    color: $text-primary;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    letter-spacing: 0.2px;
    text-transform: uppercase;
  }

  .required-mark {
    color: $danger-color;
    margin-right: 6px;
    font-weight: 900;
  }

  // Modern Input Styles
  .modern-input {
    ::v-deep {
      .v-input__slot {
        background: white !important;
        border-radius: 10px !important;
        border: 1.5px solid $border-color !important;
        transition: all 0.3s ease !important;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;

        &:hover {
          border-color: #cbd5e1 !important;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
        }
      }

      &.v-input--is-focused .v-input__slot {
        border-color: $primary-color !important;
        box-shadow: 0 0 0 4px rgba(33, 150, 243, 0.12),
          0 2px 8px rgba(0, 0, 0, 0.08) !important;
      }

      .v-input__icon--prepend-inner {
        color: $text-secondary;
        margin-right: 12px;
      }

      input::placeholder,
      .v-select__slot input::placeholder {
        color: $text-light !important;
        opacity: 1;
      }

      .v-input__prepend-inner {
        margin-right: 8px !important;
      }
    }
  }

  // Search Button
  .search-btn {
    text-transform: none !important;
    font-weight: 700 !important;
    letter-spacing: 0.5px !important;
    border-radius: 10px !important;
    padding: 12px 32px !important;
    background: linear-gradient(
      135deg,
      $primary-color 0%,
      #1976d2 100%
    ) !important;
    box-shadow: 0 4px 14px rgba(33, 150, 243, 0.3) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    height: auto !important;

    &:not(:disabled):hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 20px rgba(33, 150, 243, 0.4) !important;
    }

    &:not(:disabled):active {
      transform: translateY(-1px);
    }

    &:disabled {
      opacity: 0.6 !important;
    }
  }

  // Loading Container
  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    gap: 20px;
  }

  .loading-text {
    font-size: 14px;
    color: $text-secondary;
    font-weight: 600;
    margin: 0;
    letter-spacing: 0.3px;
  }

  // Portal & Aadhaar Details Cards
  .portal-details-card,
  .aadhaar-details-card,
  .age-proof-card {
    border: none !important;
    overflow: hidden;
    background: white !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08) !important;
    border-radius: 12px !important;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
    }
  }

  .portal-header,
  .aadhaar-header,
  .age-proof-header {
    padding: 18px 24px;
    color: white;
    font-weight: 700;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: 0.3px;
  }

  .portal-header {
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  }

  .aadhaar-header {
    &.verified {
      background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    }

    &.not-verified {
      background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    }
  }

  .age-proof-header {
    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  }

  .detail-row {
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }
  }

  .detail-label {
    font-size: 11px;
    font-weight: 800;
    color: $text-secondary;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    margin-bottom: 8px;
  }

  .detail-value {
    font-size: 15px;
    color: $text-primary;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
    letter-spacing: 0.2px;

    &.status-approved {
      color: #10b981;
      font-weight: 700;
    }

    &.status-updated {
      color: #10b981;
    }

    &.status-not-updated {
      color: #f59e0b;
    }

    &.status-verified {
      color: #10b981;
    }

    &.status-not-verified {
      color: #ef4444;
    }

    &.address-text {
      line-height: 1.5;
      max-height: 60px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  // Portal Details Grid Layout
  .portal-details-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 24px 32px;
    align-items: start;
  }

  .detail-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .detail-item .detail-label {
    font-size: 11px;
    font-weight: 800;
    color: $text-secondary;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    margin-bottom: 6px;
  }

  .detail-item .detail-value {
    font-size: 15px;
    color: $text-primary;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
    letter-spacing: 0.2px;
    line-height: 1.4;
  }

  .aadhaar-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    text-align: center;
    color: #6b7280;

    .empty-title {
      font-size: 16px;
      font-weight: 700;
      color: #e11d48;
      margin: 16px 0 8px 0;
    }

    .empty-subtitle {
      font-size: 13px;
      color: #6b7280;
      line-height: 1.6;
      margin: 0;
    }
  }

  .document-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    text-align: center;
    color: #6b7280;

    .empty-title {
      font-size: 16px;
      font-weight: 700;
      color: #8b5cf6;
      margin: 16px 0 8px 0;
    }

    .empty-subtitle {
      font-size: 13px;
      color: #6b7280;
      line-height: 1.6;
      margin: 0;
    }
  }

  // Document Image Styles
  .document-image-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .document-image-wrapper {
    position: relative;
    width: 100%;
    height: 180px;
    border-radius: 10px;
    overflow: auto;
    background: #f3f4f6;
    border: 2px solid #e5e7eb;
    transition: all 0.3s ease;
    cursor: zoom-in;

    &:hover {
      border-color: #8b5cf6;
      box-shadow: 0 8px 20px rgba(139, 92, 246, 0.15);

      .zoom-overlay {
        opacity: 1;
      }
    }

    &:active {
      cursor: zoom-out;
    }
  }

  .document-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    cursor: pointer;
    transition: transform 0.3s ease;
    display: block;

    &:hover {
      transform: scale(1.03);
    }

    &:active {
      transform: scale(1.5);
    }
  }

  .document-info {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    background: #f8fafc;
    border-radius: 10px;
  }

  .info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #e2e8f0;

    &:last-child {
      border-bottom: none;
    }
  }

  .info-label {
    font-size: 11px;
    font-weight: 800;
    color: $text-secondary;
    text-transform: uppercase;
    letter-spacing: 0.6px;
  }

  .info-value {
    font-size: 14px;
    color: $text-primary;
    font-weight: 600;
    letter-spacing: 0.2px;
  }

  // Info Fields
  .info-field {
    margin-bottom: 16px;
  }

  .info-label {
    font-size: 11px;
    font-weight: 800;
    color: $text-secondary;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    margin-bottom: 8px;
  }

  .info-value {
    font-size: 15px;
    color: $text-primary;
    font-weight: 600;
    letter-spacing: 0.2px;
  }

  // Status Field
  .status-field {
    margin-bottom: 16px;
  }

  .status-label {
    font-size: 11px;
    font-weight: 800;
    color: $text-secondary;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    margin-bottom: 10px;
  }

  .status-chip {
    font-size: 12px !important;
    font-weight: 700 !important;
    border-radius: 8px !important;
    height: 32px !important;
    letter-spacing: 0.4px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;
    transition: all 0.3s ease !important;

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18) !important;
    }

    ::v-deep {
      .v-chip__content {
        padding: 0 12px;
      }
    }
  }

  // Upload Button
  .upload-btn {
    text-transform: none !important;
    font-weight: 600 !important;
    border-radius: 10px !important;
    transition: all 0.3s ease !important;
    height: auto !important;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12) !important;
    }

    &:active {
      transform: translateY(0);
    }
  }

  // Footer Actions
  .footer-actions {
    background: white !important;
    padding: 20px 28px !important;
    border-top: 1px solid $border-color;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .action-btn {
    text-transform: none !important;
    font-weight: 700 !important;
    border-radius: 10px !important;
    padding: 10px 24px !important;
    letter-spacing: 0.3px !important;
    min-width: 150px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    height: auto !important;

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15) !important;
    }

    &:active:not(:disabled) {
      transform: translateY(0);
    }

    &:disabled {
      opacity: 0.5 !important;
    }
  }

  // Divider Enhancement
  .v-divider {
    background: linear-gradient(
      90deg,
      transparent 0%,
      $border-color 20%,
      $border-color 80%,
      transparent 100%
    ) !important;
  }

  // Responsive Design
  @media (max-width: 960px) {
    .header-content {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      padding: 20px 24px;
    }

    .header-title-section {
      width: 100%;
    }

    .close-btn {
      position: absolute !important;
      right: 20px;
      top: 20px;
    }

    .step-indicator {
      gap: 12px;
    }

    .step-number {
      width: 40px;
      height: 40px;
      font-size: 16px;
    }

    .step-title {
      font-size: 15px;
    }

    .content-container {
      padding: 20px;
    }

    .portal-details-grid {
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 16px 24px;
    }

    .step-card {
      margin-bottom: 16px !important;
    }

    .header-title {
      font-size: 26px;
    }
  }

  @media (max-width: 600px) {
    .header-content {
      padding: 16px;
    }

    .header-title {
      font-size: 22px;
    }

    .header-subtitle {
      font-size: 12px;
    }

    .title-icon-wrapper {
      width: 52px;
      height: 52px;
    }

    .content-container {
      padding: 16px;
    }

    .step-indicator {
      gap: 10px;
    }

    .step-number {
      width: 36px;
      height: 36px;
      font-size: 14px;
    }

    .step-title {
      font-size: 14px;
    }

    .portal-details-grid {
      grid-template-columns: 1fr;
      gap: 12px 16px;
    }

    .detail-item .detail-label {
      font-size: 10px;
    }

    .detail-item .detail-value {
      font-size: 14px;
    }

    .step-desc {
      font-size: 12px;
    }

    .input-label {
      font-size: 12px;
    }

    .info-value {
      font-size: 14px;
    }

    .footer-actions {
      flex-direction: column;
      padding: 16px !important;
    }

    .action-btn {
      width: 100%;
      min-width: unset;
    }
  }

  // Print Styles
  @media print {
    .close-btn {
      display: none;
    }

    .footer-actions {
      display: none;
    }
  }
}
</style>